const ONE_MEGABYTE_IN_BYTES = 1024 * 1024 * 2;

export const fileSizeValidate = (file: File, size = ONE_MEGABYTE_IN_BYTES) =>
	file?.size <= size;
